<script>
import EventBus from '../../EventBus.vue'
import QuantityCounter from './QuantityCounter.vue'

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'ActionBuilderVisibilityItems',

    components: {
        QuantityCounter
    },

    props: {
        url: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            visibileSection: null,
        }
    },




    /* Life Cycle
    --------------------------------------------------------- */

    created() {
    },


    mounted() {
        this.bindEvents()
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
    },


    watch: {
        //
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        isSectionVisible(catId) {
            if (!this.visibileSection && !catId) {
                return true
            }
            return !this.visibileSection || this.visibileSection === catId
        },

        isSectionSelected(catId) {
            if (!this.visibileSection && !catId) {
                return true
            }
            return this.visibileSection === catId
        },

        showSection(catId) {
            this.visibileSection = catId
        },

        itemChanged(el) {
            const parent = el.closest('label')
            const cb = parent.querySelector('input[type="checkbox"]')
            const itemId = cb.value
            const quantity = cb.checked ? parent.querySelector('input[type="number"]').value : 0
            this.postItem(itemId, quantity)
        },

        postItem(itemId, quantity) {
            // loading
            document.querySelector('.actionBuilder__maincol').classList.add('actionBuilderOrderSummary--loading')

            const formData = new FormData()
            formData.append('item', itemId)
            formData.append('quantity', quantity)
            formData.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'))

            const h = new Headers()
            h.append('X-Requested-With', 'XMLHttpRequest')

            fetch(this.url, {
                method: 'POST',
                headers: h,
                body: formData,
            })
                .then(response => response.text())
                .then((html) => {
                    EventBus.$emit('actionbuilder-update', { method: 'GET' })
                })
        },

        bindEvents() {
            // Listen change event on .js-ab-visibiliyitem elements
            const els = document.querySelectorAll('.js-ab-visibiliyitem input')
            els.forEach((el) => {
                el.addEventListener('change', () => {
                    this.itemChanged(el)
                })
            })
        },
    },


}

</script>
